import {ProvidingListApplication} from '../../../models/api';

export default [
  {
    id: 1,
    // isRead: true,
    statusId: 1,
    statusName: 'string',
    typeApplicationId: 1,
    typeApplicationName: 'string',
    fio: 'string',
    dateTimeFiling: '2020-02-29',
    statusHistory: [
      {
        date: '2020-02-29',
        statusId: 1,
        statusName: 'string',
        note: 'string',
      },
    ],
  },
  {
    id: 2,
    // isRead: false,
    statusId: 2,
    statusName: 'string',
    typeApplicationId: 2,
    typeApplicationName: 'string',
    dateTimeFiling: '2020-02-29',
    statusHistory: [
      {
        date: '2020-02-29',
        statusId: 1,
        statusName: 'string',
        note: 'string',
      },
      {
        date: '2020-02-29',
        statusId: 2,
        statusName: 'string',
        note: 'string',
      },
    ],
  },
] as ProvidingListApplication[];
